<template>
  <div>
    <div class="ui top attached tabular menu" ref="tabs">
      <a class="active item" data-tab="list">{{ $t("list") }}</a>
      <a class="item" data-tab="template">{{ $t("template") }}</a>
    </div>
    <div class="ui bottom attached active tab segment" data-tab="list">
      <generic-container
        v-bind:searchable="false"
        v-bind:show_plus="true"
        icon="store"
        :title="$t('store list')"
        v-on:add="add"
        :header_buttons="header_buttons"
      >
        <table
          class="ui blue very compact celled striped selectable table"
          ref="table"
          style="width:100%"
        >
          <thead>
            <tr>
              <th>{{ $t("status") }}</th>
              <th>{{ $t("name") }}</th>
              <th>{{ $t("country") }}</th>
              <!-- <th>{{ $t("phone number") }}</th> -->
              <th>{{ $t("email") }}</th>
              <th>{{ $t("users") }}</th>
              <th>{{ $t("managers") }}</th>
              <th>{{ $t("type") }}</th>
              <th>{{ $t("availability") }}</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </generic-container>
    </div>
    <div class="ui bottom attached tab segment" data-tab="template">
      <wysywyg v-model="setup.email" :show_js="false" :show_css="false" />
    </div>

    <template v-for="(mdl, index) in store_modals">
      <component
        :is="mdl"
        :key="index"
        :selected_store="selected_store"
        v-on:close="destroy"
        v-on:succedded="succedded"
      ></component>
    </template>
  </div>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import StoreModal from "@/modules/nvidia_bundle/store_modal/Index";
import { init_json_local_data_datables, local_api, error_toast } from "@/utils";
import Wysywyg from "@/components/Wysywyg/Wysywyg";

export default {
  name: "NvidiaBundleConfigurationModalStores",
  components: {
    "generic-container": GenericContainer,
    Wysywyg,
    StoreModal,
  },
  props: {
    // list: {
    //   type: Array,
    //   default: function() {
    //     return [];
    //   },
    // },
  },
  data() {
    return {
      store_modals: [],
      list: [],
      selected_store: undefined,
      system_users: [],
      setup: {
        email: {
          html: "",
          js: "",
          css: "",
        },
      },
      header_buttons: [{ icon: "refresh", click: this.init_datatable }],
    };
  },
  methods: {
    add() {
      this.store_modals.push(StoreModal);
    },
    destroy() {
      this.store_modals = [];
      this.selected_store = undefined;
    },
    succedded() {
      this.init_datatable();
      this.destroy();
    },
    init_datatable() {
      let vm = this;
      local_api(this, "post", "/nvidia_bundle/store/do-get-list")
        .then((list) => {
          if (list) {
            vm.list = list;
            let columns = [
              {
                data: function(row) {
                  // console.log(row);
                  let status = row.setup.status;
                  return status ? vm.$t("active") : vm.$t("inactive");
                },
              },
              {
                data: function(row) {
                  // console.log(row);
                  return row.setup.name;
                },
              },
              {
                data: function(row) {
                  return row.setup.country;
                },
              },
              // {
              //   data: function(row) {
              //     return row.setup.phone_number;
              //   },
              // },
              {
                data: function(row) {
                  let r = "";
                  // if (row.setup.commercial_email)
                  //   r += `<div class="ui basic label">${vm.$t("commercial")}: ${
                  //     row.setup.commercial_email
                  //   }</div>`;
                  if (row.setup.manager_email)
                    r += `<div class="ui basic label">${vm.$t("manager")}: ${
                      row.setup.manager_email
                    }</div>`;
                  return r;
                },
              },
              {
                data: function(row) {
                  let users = row.setup.associated_users.split(",");
                  let usrs = users.map((u) => {
                    if (vm.system_users) {
                      let trgtUser = vm.system_users.find((usr) => {
                        return usr.user_id == u;
                      });
                      if (trgtUser) {
                        return trgtUser.name;
                      } else {
                        return `NOT FOUND [${u}]`;
                      }
                    } else return "?";
                  });
                  return usrs.reduce(function(prev, curr) {
                    return prev + `<div class="ui basic label">${curr}</div>`;
                  }, "");
                },
              },
              {
                data: function(row) {
                  if (row.setup.manager_users) {
                    let users = row.setup.manager_users.split(",");
                    let usrs = users.map((u) => {
                      if (vm.system_users) {
                        let trgtUser = vm.system_users.find((usr) => {
                          return usr.user_id == u;
                        });
                        if (trgtUser) {
                          return trgtUser.name;
                        } else {
                          return `NOT FOUND [${u}]`;
                        }
                      } else return "?";
                    });
                    return usrs.reduce(function(prev, curr) {
                      return prev + `<div class="ui basic label">${curr}</div>`;
                    }, "");
                  } else return "";
                },
              },
              {
                data: function(row) {
                  return row.setup.type;
                },
              },
              {
                data: function(row) {
                  let r = "";
                  if (row.setup.is_api_active)
                    r += `<div class="ui basic label"><i class="green check icon" ></i>${vm.$t(
                      "api",
                    )}</div>`;
                  if (row.setup.is_exchange_page_active)
                    r += `<div class="ui basic label"><i class="green check icon" ></i>${vm.$t(
                      "exchange page",
                    )}</div>`;
                  return r;
                },
              },
            ];

            let onSelect = (data) => {
              vm.selected_store = data;
              vm.store_modals.push(StoreModal);
            };

            let onCreatedRow = () => {};
            let onPageChanged = () => {};

            init_json_local_data_datables(
              vm,
              vm.$refs.table,
              vm.list,
              columns,
              onSelect,
              onCreatedRow,
              onPageChanged,
            );
          }
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/user/do-get-all")
      .then(function(users) {
        vm.system_users = users;
        vm.init_datatable();
      })
      .catch(function(err) {
        error_toast(err);
      });

    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab();
  },
};
</script>
